module.exports = new __parcel__URL__("Camera-Potential-Doodle.8f7a62d3.mp4").toString();